import React from 'react'
import {
  Box,
  Card,
  Heading,
  Table,
  Text,
  VStack
} from '@chakra-ui/react'

interface EstimateRow {
  impressions: number
  views: { min: number; max: number }
  leads: { min: number; max: number }
  clients: { min: number; max: number }
}

const ESTIMATES: EstimateRow[] = [
  {
    impressions: 10000,
    views: { min: 40, max: 80 },
    leads: { min: 1, max: 4 },
    clients: { min: 0, max: 1 }
  },
  {
    impressions: 25000,
    views: { min: 100, max: 200 },
    leads: { min: 2, max: 10 },
    clients: { min: 1, max: 3 }
  },
  {
    impressions: 50000,
    views: { min: 200, max: 400 },
    leads: { min: 4, max: 20 },
    clients: { min: 1, max: 8 }
  },
  {
    impressions: 100000,
    views: { min: 400, max: 800 },
    leads: { min: 8, max: 40 },
    clients: { min: 2, max: 16 }
  }
]

export const EstimatesTable: React.FC = () => {
  const formatRange = (min: number, max: number) => {
    if (min === max) return min.toLocaleString()
    return `${min.toLocaleString()}–${max.toLocaleString()}`
  }

  return (
    <Card.Root borderWidth="1px" borderColor="gray.200" bg="white" borderRadius="xl" shadow="md">
      <Card.Body p={{ base: 6, md: 8 }}>
        <VStack align="stretch" gap={4}>
          <Box>
            <Heading size="md" color="gray.900" mb={2}>
              What your impressions typically produce
            </Heading>
            <Text fontSize="sm" color="gray.600">
              Conservative estimates based on typical conversion rates. Actual results may vary.
            </Text>
          </Box>
          
          <Box overflowX="auto">
            <Table.Root>
              <Table.Header>
                <Table.Row>
                  <Table.ColumnHeader>Impressions</Table.ColumnHeader>
                  <Table.ColumnHeader>Page Views</Table.ColumnHeader>
                  <Table.ColumnHeader>Leads</Table.ColumnHeader>
                  <Table.ColumnHeader>New Clients</Table.ColumnHeader>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {ESTIMATES.map((estimate, idx) => (
                  <Table.Row key={idx}>
                    <Table.Cell fontWeight="semibold">
                      {estimate.impressions.toLocaleString()}
                    </Table.Cell>
                    <Table.Cell>
                      {formatRange(estimate.views.min, estimate.views.max)}
                    </Table.Cell>
                    <Table.Cell>
                      {formatRange(estimate.leads.min, estimate.leads.max)}
                    </Table.Cell>
                    <Table.Cell>
                      {formatRange(estimate.clients.min, estimate.clients.max)}
                    </Table.Cell>
                  </Table.Row>
                ))}
              </Table.Body>
            </Table.Root>
          </Box>
        </VStack>
      </Card.Body>
    </Card.Root>
  )
}
